import { ReportAllocatedAndSubsidies42Container } from "../../../containers/SupportSystem/Reports/ReportAllocatedAndSubsidies42Container";
export function ReportAllocatedAndSubsidies42Page() {
    return (
        <ReportAllocatedAndSubsidies42Container />
    );

}